import { Controller } from "@hotwired/stimulus";

// Episode Actions Dropdown Controller
export default class extends Controller {
  static targets = ["dropdown"];
  static values = { episodeId: String };

  connect() {
    // Close dropdown when clicking outside
    document.addEventListener("click", this.closeOnClickOutside.bind(this));
    // Close dropdown on escape key
    document.addEventListener("keydown", this.closeOnEscape.bind(this));
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside.bind(this));
    document.removeEventListener("keydown", this.closeOnEscape.bind(this));
  }

  toggle() {
    // Close all other open dropdowns
    document
      .querySelectorAll(".episode-actions-dropdown")
      .forEach((otherDropdown) => {
        if (otherDropdown !== this.dropdownTarget) {
          otherDropdown.classList.add("hidden");
        }
      });

    // Toggle current dropdown
    this.dropdownTarget.classList.toggle("hidden");
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  close() {
    this.dropdownTarget.classList.add("hidden");
  }
}
